export const DELETE_ROLE = 'DELETE_ROLE';
export const REFRESH_ROLES = 'REFRESH_ROLES';
export const UPDATE_ROLE = 'UPDATE_ROLE';
export const ADD_ROLE = 'ADD_ROLE';